import { ActionBar } from '@frontend/action-bar';
import { useTranslation } from '@frontend/i18n';

export type TeamChatButtonProps = {
  onClick: () => void;
  shouldShowDot: boolean;
  isActive: boolean;
  status?: 'error' | 'warning' | 'loading';
};

export const TeamChatButton = ({ onClick, isActive, shouldShowDot, status }: TeamChatButtonProps) => {
  const { t } = useTranslation('team-chat');
  return (
    <ActionBar.Action
      label={t('Team Chat')}
      id='team-chat-v2'
      icon='chat'
      onClick={onClick}
      trackingId={'chat-v2-tray-trigger'}
      hasCount
      hasDot={shouldShowDot}
      isActive={isActive}
      status={status}
    />
  );
};
